import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import es from './locales/es.json'
// import ru from './locales/ru.json'

const messages = {
  en,
  es,
  // ru
}

// Define available locales type
type Locale = keyof typeof messages

// Get saved language from localStorage or default to 'en'
const savedLocale = localStorage.getItem('app-language') || 'en'
const locale = Object.keys(messages).includes(savedLocale) ? savedLocale : 'en'

const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: 'en',
  messages
})

// Function to change language dynamically
export const changeLanguage = (newLocale: string): boolean => {
  if (Object.keys(messages).includes(newLocale)) {
    i18n.global.locale.value = newLocale as Locale
    localStorage.setItem('app-language', newLocale)
    return true
  }
  return false
}

// Get available languages
export const getAvailableLanguages = () => {
  return Object.keys(messages).map(code => ({
    code,
    name: code === 'en' ? 'English' : code === 'es' ? 'Español' : code === 'ru' ? 'Русский' : code
  }))
}

export default i18n
